<template>
  <div ref="container">
    <a-modal
      :title="title"
      width="100vw"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
    >
      <div class="list-wrapper">
        <a-tabs v-model:activeKey="activeKey"  @change="handleTabChange">
          <a-tab-pane key="1" tab="扫码录入">
            <div class="scan-wrapper">
              <a-button @click="handleScanStart">开始扫码</a-button>
              <div class="scanContent">
                <a-list>
                    <a-list-item v-for="(item, index) in scanData" :key="index">
                        {{ index + 1 }}. {{ item }}
                    </a-list-item>
                </a-list>
            </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="码段">
            <a-list>
                <a-list-item v-for="(item, index) in getProductCode" :key="index">
                    {{ index + 1 }}. {{ item.idCode }}
                </a-list-item>
                <a-pagination
                  v-model:current="currentPage"
                  :total="total"
                  :page-size="pageSize"
                  @change="handlePageChange"
                  show-less-items
                  style="margin-top: 16px; text-align: center;"
                />
            </a-list>
            <a-modal
                title="配置码段"
                :visible="activeVisible"
                @ok="handleActiveOk"
                @cancel="handleActiveCancel"
            >
                <a-form :form="activeForm">
                    <a-form-item label="开始" name="startCode">
                        <a-input v-model="activeForm.startCode" placeholder="请输入开始商品码" />
                    </a-form-item>
                    <a-form-item label="结束" name="endCode">
                        <a-input v-model="activeForm.endCode" placeholder="请输入结束商品码" />
                    </a-form-item>
                </a-form>
            </a-modal>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { saveTempCode, traceSaveForPlanId, getCodeSegmentList } from '@/api/api'
export default {
  name: '扫码',
  data() {
    return {
      title: "操作",
      visible: false,
      scanData: [],
      currentScan: '',
      isScanning: false,
      activeVisible: false,
      planRecordId: null,
      activeKey: '1', // 默认激活第一个标签页
      checkType: 1,
      startCode: '',
      activeForm: {},
      endCode: '',
      recordsInfo: {},
      getProductCode: [],
      currentPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    paginatedProductCode() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.getProductCode.slice(start, end);
    },
  },
  methods: {
    show(e) {
      this.visible = true;
      this.planRecordId = e.id
      this.recordsInfo = e
      console.log(this.recordsInfo,'recordsInfo==========')
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    // 开始扫码
    handleScanStart() {
      if (!this.isScanning) {
        this.isScanning = true;
        this.currentScan = ''; // 清空当前累积的数据
        window.addEventListener('keydown', this.handleKeyPress);
      }
    },

    // 重新开始扫码
    handleScanRestart() {
      if (!this.isScanning) {
        this.isScanning = true;
        this.currentScan = ''; // 清空当前累积的数据
        window.addEventListener('keydown', this.handleKeyPress);
      }
    },

    handleKeyPress(event) {
      if (!this.isScanning) return;

      // 捕获扫码数据
      const key = event.key;
      // console.log(key, '扫码数据');

      // 忽略 Shift 键
      if (key.toLowerCase() === 'shift' || key.toLowerCase() === 'alt' || key.toLowerCase() === 'arrowleft' || key.toLowerCase() === 'arrowup' || key.toLowerCase() === 'pagedown' || key.toLowerCase() === 'insert' || key.toLowerCase() === 'end') {
        return;
      }

      // 忽略 F12 和 ControlInsert
      if (key === 'F12' || key === 'ControlInsert') {
        return;
      }

      // 假设扫码结束符是回车键
      if (key === 'Enter') {
        this.isScanning = false;
        window.removeEventListener('keydown', this.handleKeyPress);
        if ( this.currentScan !== '' ){
          const isExist = this.scanData.some(item => item === this.currentScan.trim());
          if (isExist) {
            this.$message.error('重复');
            this.currentScan = ''; // 清空当前累积的数据
            this.handleScanRestart(); // 重新开始监听键盘事件
            return;
          } else {
            this.saveCode(this.currentScan)
            // this.scanData.push(this.currentScan.trim());
            // this.currentScan = ''; // 清空当前累积的数据
          }
        } else {
          return;
        }
        
      } else {
        if (key.length === 1 && key !== 'undefined') {
          this.currentScan += key;
        }
        // console.log(this.currentScan, 'this.currentScan==============');
      }
    },
    handleTabChange(checkType){
      this.checkType = checkType;
      if ( this.checkType === '2' ){
        this.getCodeSegmentLists()
      }
    },
    async saveCode(e){
      const params = { 
        objectCode: e,
        planRecordId: this.planRecordId,
       }

      saveTempCode(params).then(res => {
        if (res.code === 200 && res.success === true) {
          this.$message.success('成功');
          this.scanData.push(e.trim());
          this.currentScan = ''; // 清空当前累积的数据
          this.handleScanRestart(); // 重新开始监听键盘事件
        } else {
          this.$message.error(res.message);
          this.currentScan = ''; // 清空当前累积的数据
          this.handleScanRestart(); // 重新开始监听键盘事件
        }
      })
    },
    handleCancel(event) {
      event.preventDefault();
      // 移除 this.close() 以防止模态框关闭
      this.scanData = []
      this.visible = false
    },
    // 获取码段列表
    async getCodeSegmentLists(){
      console.log(this.recordsInfo,'recordsInfo==========')
      const params = {
          materialId: this.recordsInfo.materialId,
          processId: this.recordsInfo.processId, // 工序ID
          craftlId: this.recordsInfo.craftId,
          pageSize: 10,
          currentPage: 1
      }
      const res = await getCodeSegmentList(params)
      console.log(res,'码段列表===============')
      if( res.code == 200 && res.success == true ){
          this.getProductCode = res.result.records
          this.total = res.result.total
      } else {
          this.$message.error('获取码段列表失败')
      }
      
    },
    
    handleActiveOk(){
      this.activeVisible = false
      this.saveData()
    },
    handleActiveCancel(){
      this.activeVisible = false
    },
    handleOk(event) {
      event.preventDefault();
      // 移除 this.close() 以防止模态框关闭
      if (this.activeKey === '1') {
        // 用户在“扫码录入”标签页点击了保存
        console.log('保存扫码录入数据:', this.scanData);
        this.saveData()
        // 在这里添加保存扫码录入数据的逻辑
      } else if (this.activeKey === '2') {
        // 用户在“码段”标签页点击了保存
        console.log('保存码段数据');
        this.activeVisible = true
        // 在这里添加保存码段数据的逻辑
      }
      this.visible = false
    },
    async saveData(){
      const params = { 
        planId: this.planRecordId,
        checkType: this.checkType,
        startCode: this.activeForm.startCode,
        endCode: this.activeForm.endCode,
        saveType : 1 // 1保存追溯平台 2保存本地
       }
      const res = await traceSaveForPlanId(params)
      if (res.code === 200 && res.success == true ) {
        this.$message.success(res.result);
        this.visible = false;
        this.scanData = []
      } else {
        this.$message.error(res.result);
      }
    }
  }
}
</script>